import { YmkSdkShadeFinderConfiguration } from "@hermes/api-model-shade-finder";

import { SHADE_FINDER_CONFIGURATION_UNDEFINED } from "../constants/shade-finder.constant";

export interface ShadeFinderCameraDimension {
    width: number;
    height: number;
}
export enum ShadeFinderModalStatus {
    "NONE" = "NONE",
    "MODAL_OPENED" = "MODAL_OPENED",
    "MODAL_CLOSED" = "MODAL_CLOSED",
    "CAMERA_LOADING" = "CAMERA_LOADING",
    "CAMERA_LOADED" = "CAMERA_LOADED",
    "ON_ERROR" = "ON_ERROR",
}

export enum ShadeFinderSdkError {
    "NO_ERROR" = "NO_ERROR",
    "ERROR_CAMERA" = "ERROR_CAMERA",
    "ERROR_RESOLUTION" = "ERROR_RESOLUTION",
    "ERROR_TIMEOUT" = "ERROR_TIMEOUT",
}

export type ShadeFinderConfigurationUndefined =
    typeof SHADE_FINDER_CONFIGURATION_UNDEFINED;
export type ShadeFinderConfigurationState =
    | ShadeFinderConfigurationUndefined
    | YmkSdkShadeFinderConfiguration;
